/* @flow */

export default class InvestmentProfileDefaults {
  amountMinValue: number;
  minAmountMinValue: number;
  maxAmountMinValue: number;
  maxAmountMultiplier: number;
}
